const sortBy = require("lodash/sortBy");
const { inputTypes, isOptionBasedInputType } = require("../../constants/form-input-types");
// What a visitor picked, as one string, for the event's `info3` column. Same separator HubSpot gets
// for a multi-select (see convertValuesToHubspotFormat), so a selection reads identically in the
// blur event and in the submit event.
const SELECTED_VALUES_SEPARATOR = ";";
// `info2` and the condition for the "typed" event are deliberately left as they always were:
// `value?.length`, which is the option count for a multi-select, the character count for free text,
// and `undefined` for a single-select, whose value is one option object with no length of its own.
// Everything this event learned is additive (`info3`, `data`), so no dashboard, ETL or event-anomaly
// alert reading the old columns sees a step change in volume or meaning on release. Widening this is
// a decision for whoever owns those dashboards, not a side effect of a payload change.
const getLegacyValueLength = (value)=>value === null || value === void 0 ? void 0 : value.length;
/**
 * Whether the "typed" event fires — the original condition, unchanged.
 */ const shouldTrackTypedEvent = (value)=>getLegacyValueLength(value) > 0;
// Values straight off the option list rather than translated labels, so the event doesn't change
// when copy or locale does. The longest selection in use (every what-to-achieve option) joins to
// ~220 characters.
const toSelectedValues = (inputConfig, value)=>{
    if (value === null || value === undefined || value === "") return [];
    // Multi-value select: react-select gives an array of { label, value } option objects.
    if (Array.isArray(value)) {
        const optionOrder = ((inputConfig === null || inputConfig === void 0 ? void 0 : inputConfig.options) || []).map((option)=>option.value);
        return sortBy(value.map((option)=>option === null || option === void 0 ? void 0 : option.value).filter((optionValue)=>optionValue !== undefined), (optionValue)=>optionOrder.indexOf(optionValue));
    }
    // Single-value select rendered by the same react-select input (company size): one option object.
    if (typeof value === "object") {
        return value.value === undefined ? [] : [
            value.value
        ];
    }
    // Checkbox. No input wires onBlur to a checkbox today, so this only keeps the shape sane.
    if (typeof value === "boolean") {
        return value ? [
            String(value)
        ] : [];
    }
    // Native <select>: the option itself is the value.
    return [
        String(value)
    ];
};
const isMultiValueSelect = (inputConfig)=>(inputConfig === null || inputConfig === void 0 ? void 0 : inputConfig.type) === inputTypes.MULTI_SELECT && !!(inputConfig === null || inputConfig === void 0 ? void 0 : inputConfig.isMulti);
/**
 * BigBrain payload for a contact-form field interaction (hubspot_form_input_blur / _typed).
 *
 * `kind`, `info1` and `info2` are what they have always been. `info3` and `data.selected_values` are
 * new, and they name what the visitor picked only for inputs whose value comes from a fixed option
 * list — free text is the visitor's own words and may be PII, so it is measured, never reported. An
 * input missing from the form config is treated as free text.
 */ const getFormInputEventData = ({ formId, inputName, inputConfig, value })=>{
    const fieldType = (inputConfig === null || inputConfig === void 0 ? void 0 : inputConfig.type) || null;
    const eventData = {
        kind: formId,
        info1: inputName,
        info2: getLegacyValueLength(value),
        data: {
            field_name: inputName,
            field_type: fieldType
        }
    };
    if (!isOptionBasedInputType(fieldType)) {
        var _getLegacyValueLength;
        eventData.data.value_length = (_getLegacyValueLength = getLegacyValueLength(value)) !== null && _getLegacyValueLength !== void 0 ? _getLegacyValueLength : 0;
        return eventData;
    }
    const selectedValues = toSelectedValues(inputConfig, value);
    eventData.info3 = selectedValues.join(SELECTED_VALUES_SEPARATOR);
    eventData.data.is_multi_select = isMultiValueSelect(inputConfig);
    eventData.data.selected_count = selectedValues.length;
    eventData.data.selected_values = selectedValues;
    return eventData;
};
module.exports = {
    SELECTED_VALUES_SEPARATOR,
    getFormInputEventData,
    shouldTrackTypedEvent
};
